/**
 * Tutor modes and the live session meter.
 *
 * Owner (DEV 2026-09-24): two modes the learner can talk or type in - Voice (the tutor speaks) and
 * Text (the tutor writes) - items 5 and 9; talk mode sat on "Connecting..." (item 8); an exhausted
 * allowance must stop the tutor mid-way with a clear message (item 11). Sol owner14 Q2 and
 * owner14-e (A): the worker extends the session and sends what is left on topic quiklearn-meter.
 */
export const METER_TOPIC = 'quiklearn-meter';

/** "Text": type or speak, the tutor replies in writing. The backend bills it to the Text meter. */
export const TEXT_MODE = 'HYBRID';

export const writesReplies = mode => mode === 'TEXT' || mode === 'HYBRID';
export const listensToLearner = mode => mode === 'VOICE' || mode === 'HYBRID';

const decode = payload => {
  if (typeof payload === 'string') return payload;
  try {
    return new TextDecoder().decode(payload);
  } catch (_) {
    return '';
  }
};

/** {type: 'meter', secondsLeft} or {type: 'ended', ...}; null for anything else. */
export const parseMeterMessage = payload => {
  let data;
  try {
    data = JSON.parse(decode(payload));
  } catch (_) {
    return null;
  }
  if (data?.type === 'meter' && Number.isFinite(data.secondsLeft)) return data;
  if (data?.type === 'ended') return data;
  return null;
};

export const minutesLeftLabel = seconds => {
  if (!Number.isFinite(seconds)) return null;
  if (seconds < 60) return 'Less than a minute left';
  return `${Math.floor(seconds / 60)} min left`;
};

const modeName = meter => (meter === 'voice' ? 'Voice' : 'Text');

/** What the learner is told when a session ends; the shape the usage panel shows. */
export const sessionEndNotice = ended => {
  const reason = ended?.reason || 'SESSION_ENDED';
  const meter = ended?.meter === 'voice' ? 'voice' : 'text';
  if (reason === 'QUOTA_EXHAUSTED' || reason === 'NO_SUBSCRIPTION') {
    const other = Number(ended?.otherSecondsLeft);
    const otherName = modeName(ended?.otherMeter);
    const rest = ended?.otherMeter && Number.isFinite(other) && other >= 60
      ? ` You still have ${Math.floor(other / 60)} ${otherName} minutes: start the tutor again and choose ${otherName}.`
      : '';
    return {
      kind: 'quota',
      meter,
      message: reason === 'NO_SUBSCRIPTION'
        ? 'Your plan is no longer active, so the tutor has stopped.'
        : `Your ${modeName(meter)} minutes for this month are used up.${rest}`,
    };
  }
  return {
    kind: 'ended',
    meter,
    message: reason === 'PERIOD_ENDED'
      ? 'Your plan renewed during this session. Start the tutor again to keep going.'
      : 'Your tutor session has ended. Start the tutor again to keep going.',
  };
};
